import { FieldSetsForm } from "lego-gui-lib/lib/components/Views/ShowView/FieldSetsForm";
import { inject } from "mobx-react";
import React from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import {
  CreateView,
  IndexView,
  ShowView,
  withBreadCrumbs
} from "lego-gui-lib/lib";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../common/tabContainers";
import { DestinationSchemaColumns, DestinationSchemaForm } from "./schema";
import { isAllowed } from "../../common/common";
import { observer } from "mobx-react-lite";

export const DestinationViewComponent = () => {
  const match = useRouteMatch();
  const baseUrl = match.path;
  return (
    <Switch>
      <Route exact={true} path={baseUrl} component={DestinationIndex} />
      <Route path={baseUrl + "/create/:id"} component={Create} />
      <Route path={baseUrl + "/create"} component={Create} />
      <Route path={baseUrl + "/:id"} component={Show} />
    </Switch>
  );
};

const injectDataSource = (comp: any) =>
  inject("destination", "i18n", "SAN", "commons")(observer(comp));

export const DestinationIndex = injectDataSource(
  ({ destination, i18n, SAN, ...rest }: any) => {
    const title = i18n.t("hns:destination:domain", { count: 2 });
    return (
      <IndexView
        dataSource={destination.listDataSource}
        {...rest}
        title={title}
        titleVariant={"h5"}
        toolbarButtons={{ delete: true, export: true }}
        rowButtons={{ edit: true, delete: true, copy: true, export: true }}
        columns={DestinationSchemaColumns(SAN)}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ destination, i18n, SAN, match, ...rest }: any) => {
    const title = i18n.t("common:create", { domain: "hns:destination:domain" });
    const baseUrl = match.url;
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/create", children: title },
      <CreateView
        dataSource={destination.oneDataSource}
        {...rest}
        Presentation={FieldSetsForm}
        title={title}
        fields={DestinationSchemaForm(SAN)}
        id={match.params}
        initialValues={{
          maxCalls: 0,
          queueActive: 0
        }}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Show = injectDataSource(
  ({ destination, i18n, SAN, match }: any) => {
    const allowed = isAllowed(destination);
    const title = allowed
      ? i18n.t("common:edit", { domain: "hns:destination:domain" })
      : i18n.t("hns:destination:domain");
    const baseUrl = match.url;
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/edit", children: title },
      <ShowView
        dataSource={destination.oneDataSource}
        title={title}
        Presentation={FieldSetsForm}
        fields={DestinationSchemaForm(SAN)}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);
